import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mbs-card-group',
  templateUrl: './card-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'mbs-card_group'
  }
})
export class CardGroupComponent {}
